import { Component, input, output, OnInit, signal, computed } from "@angular/core";
import { NgClass } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { CollapseDirective } from "ngx-bootstrap/collapse";

@Component({
  selector: "portal-accordion-element",
  templateUrl: "./accordion-element.component.html",
  styleUrls: ["./accordion-element.component.scss"],
  standalone: true,
  imports: [NgClass, TranslatePipe, CollapseDirective],
})
export class AccordionElementComponent implements OnInit {
  readonly isCollapsed = input(true);
  readonly isCurrentlyCollapsed = signal(true);
  readonly id = input("");
  readonly label = input("");
  readonly isHeadingBold = input(true);
  readonly useTranslation = input(true);
  readonly isFirstElement = input(true);
  readonly leftImage = input("");
  readonly leftIcon = input("");
  readonly icon1 = input("");
  readonly icon2 = input("");
  readonly accordionSpacerClass = signal("");
  readonly labelClass = computed(() => {
    if (this.leftIcon() && !this.icon1() && !this.icon2()) {
      return "col-8 col-md-10";
    } else if (!this.leftIcon() && !this.icon1 && !this.icon2()) {
      return "col-10 col-md-10";
    } else if (this.leftIcon() && this.icon1() && this.icon2()) {
      return "col-8 col-md-8";
    }
    return "";
  });

  readonly elementClicked = output<boolean>();

  ngOnInit() {
    this.isCurrentlyCollapsed.set(this.isCollapsed());
  }

  click(): void {
    this.isCurrentlyCollapsed.set(!this.isCurrentlyCollapsed());
    this.elementClicked.emit(true);
  }
}
